/**
 * @ngdoc directive
 * @name newspanel
 *
 * @description
 * Panel for last news display
 */
module.directive('newspanel', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        controller: ['$scope', '$filter', '$window', 'lodash', function ($scope, $filter, $window, lodash) {
            $scope.articlesPerLine = 1;
            $scope.defaultArticlesPerLine = 3;

            $scope.position = 0;
            $scope.sliderWidth = 0;
            $scope.slideWidth = 0;

            /* add slug to news (zoom) */
            if ($scope.content.field_news) {
                $scope.content.field_news.slug = $filter('slugify')($scope.content.field_news.title);
            }
            /* add slug to news*/
            if ($scope.content.field_articles) {
                $scope.content.field_articles.forEach(function (article) {
                    if(angular.isUndefined(article) || article !== null){
                        article.slug = $filter('slugify')(article.title);
                    }
                });
                // Reverse an array
                $scope.content.field_articles.reverse();
            }

            $scope.getSlideWidth = function () {
                if ($scope.slideWidth !== 0) {
                    return $scope.slideWidth;
                }
                // console.log('getSlideWidth');
                var boundings = document.querySelector('.aqua-newspanel--article').getBoundingClientRect();
                var width = Math.round(boundings.width);
                // console.log('found slide width of', width, 'px');
                $scope.slideWidth = width;
                return width;
            };
            $scope.getSliderWidth = function() {
                if ($scope.sliderWidth !== 0) {
                    return $scope.sliderWidth;
                }
                // console.log('getSliderWidth');
                var boundings = document.querySelector('.aqua-newspanel--news_container').getBoundingClientRect();
                var width = Math.round(boundings.width);
                // console.log('found slider width of', width, 'px');
                $scope.sliderWidth = width;
                return width;
            };
            var getSlidesCount = function(nbArticles, max) {
                var width = $scope.getSlideWidth();
                $scope.articlesPerLine = width === $scope.sliderWidth ? 1 : $scope.defaultArticlesPerLine;
                // console.log('articlesPerLine is ', $scope.articlesPerLine);
                return Math.min(Math.ceil(nbArticles / $scope.articlesPerLine), max || Infinity);
            };
            $scope.getSlidesRange = function(nbArticles, max) {
                // console.log('slidesRange:',getSlidesCount(nbArticles));
                return new Array(getSlidesCount(nbArticles, max));
            };

            var clearSliderWidth = function() {
                // console.log('clearSliderWidth');
                // reset values
                $scope.position = 0;
                $scope.sliderWidth = 0;
                $scope.slideWidth = 0;
                // force layout (products per slide may differ)
                $scope.$digest();
            };

            $scope.changeSlide = function (index) {
                $scope.position = index;
            };

            $scope.nextSlide = function() {
                if ($scope.position < (getSlidesCount($scope.content.field_articles.length) - 1)) {
                    $scope.position++;
                }
            };
            $scope.prevSlide = function() {
                if ($scope.position > 0) {
                    $scope.position--;
                }
            };

            // reestimate slider with when window is resized
            $window.onresize = lodash.throttle(clearSliderWidth, 1000);
        }],
        templateUrl: 'src/components/newspanel/newspanel.html'
    };
});
